/** ViewModelBase is the base class of all ViewModels */
export default abstract class ViewModelBase {
  abstract initialize(): Promise<void>;
}
